// extracted by mini-css-extract-plugin
export default {"searchFacetsContainer":"searchFacetsContainer__ZTNmN","active":"active__NzVhZ"};